import type {
  CargoProblemCategory,
  CargoProblemEventKind,
  CargoProblemQueue,
  CargoProblemStatus,
  CargoProblemTerminalOutcome,
} from '@magimp/shared';
import { useTranslation } from 'react-i18next';
import type { StatusBadgeStatus } from '../../ui/index.js';

export const CARGO_PROBLEM_STATUSES: readonly CargoProblemStatus[] = [
  'DRAFT',
  'NEW',
  'REJECTED',
  'IN_PROGRESS',
  'REVIEW',
  'NOT_RESOLVED',
  'PARTIALLY_RESOLVED',
  'RESOLVED',
];
export const CARGO_PROBLEM_CATEGORIES: readonly CargoProblemCategory[] = [
  'SUPPLIER',
  'CHINA_WAREHOUSE',
  'CHINA_CARRIER',
  'RUSSIA_WAREHOUSE',
  'RUSSIA_CARRIER',
];
export const CARGO_PROBLEM_QUEUES: readonly CargoProblemQueue[] = [
  'CHINA_LOGISTICS',
  'RUSSIA_LOGISTICS',
];
export const CARGO_PROBLEM_OUTCOMES: readonly CargoProblemTerminalOutcome[] = [
  'NOT_RESOLVED',
  'PARTIALLY_RESOLVED',
  'RESOLVED',
];

const STATUS_BADGE: Record<CargoProblemStatus, StatusBadgeStatus> = {
  DRAFT: 'draft',
  NEW: 'system',
  REJECTED: 'return',
  IN_PROGRESS: 'inWork',
  REVIEW: 'system',
  NOT_RESOLVED: 'return',
  PARTIALLY_RESOLVED: 'system',
  RESOLVED: 'processed',
};

export function cargoProblemBadgeStatus(status: CargoProblemStatus): StatusBadgeStatus {
  return STATUS_BADGE[status];
}

export function useCargoProblemLabels() {
  const { t } = useTranslation('cargoProblems');
  return {
    status: (value: CargoProblemStatus) => t(`statuses.${value}`),
    category: (value: CargoProblemCategory) => t(`categories.${value}`),
    queue: (value: CargoProblemQueue) => t(`queues.${value}`),
    outcome: (value: CargoProblemTerminalOutcome) => t(`statuses.${value}`),
    event: (value: CargoProblemEventKind) => t(`events.${value}`),
  };
}
